module.exports = __webpack_public_path__ + "img/atendimento-empty-state.a45755ec.svg";